import { createUserDAO } from '@rapid-recovery-agency-inc/insightt-graphql';

export enum UserStatsTabType {
  TODAY = 'today',
  THIS_WEEK = 'this-week',
  THIS_MONTH = 'this-month',
  YTD = 'ytd',
}

export interface TimeRangeString {
  startDate: string;
  endDate: string;
  prevStartDate: string;
  prevEndDate: string;
}

export type UserDaoType = ReturnType<typeof createUserDAO>;
